import { get, post, del } from './API';

export default {
  fetchOperators: async () => get('operators'),
  /**
   * Create (no `Id`) or update (with one) a single operator record.
   *
   * `absorbed_ids` is the one field the API leaves alone when it is omitted,
   * so an ordinary save can never clear a pairing somebody set deliberately —
   * send it only when the pairing itself is what is being changed.
   */
  saveOperator: async (operator) => post('operators', operator),
  fetchDrivers: async (operatorId) => get('/operators/drivers', { operatorId }),
  fetchCars: async (operatorId) => get('/operators/cars', { operatorId }),
  addDriver: async (driver) => post('operators/drivers', driver),
  addCar: async (car) => post('operators/cars', car),
  deleteDriver: async (id) => del('operators/drivers', { id }),
  deleteCar: async (id) => del('operators/cars', { id }),
};
